<template>
    <div>
        <HelpSelfPublishing v-if="isSelfPublishingSystemEnabled" class="mb-3"/>
        <HelpShop v-if="frontConfig.isShopSectionEnabled" class="mb-3"/>
        <HelpProfile class="mb-3"/>
        <HelpOrders class="mb-3"/>
        <HelpOther/>
    </div>
</template>

<script>
import HelpProfile from "./HelpProfile";
import HelpShop from "./HelpShop";
import HelpOrders from "./HelpOrders";
import HelpOther from "./HelpOther";
import {mapGetters} from "vuex";
import HelpSelfPublishing from "@/components/Hermes/Help/HelpSelfPublishing";
export default {
    name: "HelpAll",
    components: {HelpSelfPublishing, HelpOther, HelpOrders, HelpShop, HelpProfile},
    computed: {
        ...mapGetters("config", {
            frontConfig: "front",
            isSelfPublishingSystemEnabled: "isSelfPublishingSystemEnabled",
        }),
    },
};
</script>

<style scoped>

</style>